import { useEffect, useMemo, useCallback } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ReactPaginate from 'react-paginate';
import { useMain } from '../../contexts/MainContext';

import api from "../../services/api";

import { Header } from "../../components/Header";
import { ModalAdd } from "../../components/ModalAdd";
import { ModalEdit } from "../../components/ModalEdit";
import { ModalDelete } from "../../components/ModalDelete";
import { Botao } from "../../components/Botao";

import Edit from '../../assets/edit.svg';
import Checked from '../../assets/checked.svg';
import Unchecked from '../../assets/unchecked.svg';
import Trash from '../../assets/trash.svg'; 

import { Container, Title, Table } from './styles';

export function InstitucionalHorarios() {

    const title = "Horário de Funcionamento";

    const fields = useMemo(() => 
        [
            {
               id: "Horário de Funcionamento",
               title: String,
               text: String,
               status: Number
            }
        ],
        []
    );

    const {
        horarios, 
        setHorarios,
        modalAdd,  
        toggleModalAdd,
        modalEdit,
        toggleModalEdit,
        modalDelete,
        toggleModalDelete,
        id,
        setID,
        offset, 
        limit, 
        handlePageClick 
    } = useMain();

    const pageCount = Math.ceil(horarios.length / limit);
    
    const loadHorarios = useCallback( async () => {

        try {
            const response = await api.get('horarios');

            setHorarios(response.data);    

        } catch (error) {
            console.log("Ocorreu um erro ao buscar as informações necessárias");
        }
        
    }, [setHorarios]);

    useEffect(() => {
        loadHorarios();
    }, [loadHorarios]);

    

    return (
        <>
            <ToastContainer />

            {modalAdd && (<ModalAdd isClose={toggleModalAdd} isLoad={loadHorarios} fields={fields} name="horarios" title="Horário de Funcionamento" />)}
            {modalDelete && (<ModalDelete isClose={toggleModalDelete} isLoad={loadHorarios} id={id} name="horarios" title="Horário de Funcionamento" />)}
            {modalEdit && (<ModalEdit isClose={toggleModalEdit} isLoad={loadHorarios} id={id} name="horarios" title="Horário de Funcionamento" /> )}

            <Header title={title} />

            <Container>
                <Title>Gerenciador de Horários de Funcionamento</Title>
                {horarios.length <= 0 ? (
                    <>
                        Nenhuma informação cadastrada.
                    </>
                ) : (
                    <>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Exibição</th>
                                    <th>Título</th>
                                    <th>Horário</th>
                                    <th>Status</th>
                                    <th colSpan="2"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {horarios && (
                                    horarios.slice(offset, offset + limit).map(servico => ( 
                                        <tr key={servico.id}>
                                            <td>{servico.id}</td>
                                            <td>{servico.title}</td>
                                            <td>{servico.text.replace(/<[^>]*>/g, '')}</td>
                                            <td>{servico.status === 1 ? <img src={Checked} alt="Ativo" />  : 
                                                <img src={Unchecked} alt="Inativo" />}</td>
                                            <td onMouseDown={() => setID(servico.id)}>
                                                <img src={Edit} alt="Editar" title="Editar" onClick={toggleModalEdit} />
                                            </td>
                                            <td onMouseDown={() => setID(servico.id)}>
                                                <img src={Trash} alt="Deletar" title="Deletar" onClick={toggleModalDelete} />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>

                        <ReactPaginate
                            previousLabel={"<"}
                            nextLabel={">"}
                            pageCount={pageCount}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            previousLinkClassName={"pagination__link"}
                            nextLinkClassName={"pagination__link"}
                            disabledClassName={"pagination__link--disabled"}
                            activeClassName={"pagination__link--active"}
                        />
                    </>
                )}
            </Container>

            <Botao isOpen={toggleModalAdd} />

        </>
    );
}
